import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className='footer mt_40'>
      <div className='container-fluid'>
        <div className='row'>
          <div className='col-md-12 text-center'>
            <p>© {currentYear} UnivisionCPA. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
